"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = require("../../../atoms/Button/Button");
var EditorFooter_logic_1 = require("./EditorFooter.logic");
var EditorFooter_static_1 = require("./EditorFooter.static");
var EditorFooter = function (_a) {
    var initialState = _a.initialState, onDiscard = _a.onDiscard, onSave = _a.onSave, saving = _a.saving, setEditorKey = _a.setEditorKey, setEditorRef = _a.setEditorRef, setState = _a.setState, state = _a.state;
    var _b = (0, EditorFooter_logic_1.useEditorFooter)({
        initialState: initialState,
        onDiscard: onDiscard,
        onSave: onSave,
        saving: saving,
        setEditorKey: setEditorKey,
        setEditorRef: setEditorRef,
        setState: setState,
        state: state,
    }), classes = _b.classes, isDisabled = _b.isDisabled, discardProps = _b.discardProps, saveProps = _b.saveProps;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.root }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.buttons }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { title: EditorFooter_static_1.localText.discard, variant: 'secondary', onClick: discardProps.onClick, isDisabled: isDisabled }), (0, jsx_runtime_1.jsx)(Button_1.Button, { title: EditorFooter_static_1.localText.save, variant: 'primary', onClick: saveProps.onClick, isDisabled: isDisabled, isLoading: saving, tooltip: saveProps.tooltip })] })) })));
};
exports.default = EditorFooter;
